<template>
<div class="u-centerboth">
  <div class="u-stars">
    <i class="fa fa-star u-star" aria-hidden="true"></i>
    <i class="fa fa-star  u-star" aria-hidden="true"></i>
    <i class="fa fa-star  u-star" aria-hidden="true"></i>
    <i class="fa fa-star  u-star" aria-hidden="true"></i>
    <i class="fa fa-star  u-star" aria-hidden="true"></i>
  </div>
</div>
</template>

<script>
import CheckBox from "@/components/PdkCheckBox";
export default {
  data: () => ({ selected: -1 }),
  components: { "pdk-ckeckbox": CheckBox },
  name: "pdkCheckBox",
  props: { rooms: Array },
  methods: {
    book() {
      const room = this.rooms.find(t=>t.roomTypeCode == this.selected);
      if (room == null) return;
      const rooms = Array();
      rooms.push(room)
      this.$emit("book", rooms);
    },
  },
};
</script>
<style lang="css" scoped>
.u-centerboth {
    margin-top: 6px;
}
.u-stars {
  color: #fcbe2f;
  font-size: 16px;
}

.u-star {
  opacity: 0.7;
  padding-left: 3px;
}
</style>